import {
  DELETE_MANAGER,
  SET_LOADING,
  UPDATE_MANAGERS,
} from './actions/managers'
import { RepositoryFactory } from '@/api/RepositoryFactory'

const Managers = RepositoryFactory.get('managers')

export default {
  namespaced: true,
  state: {
    managers: [],
    loading: false,
  },
  getters: {
    getManagers: state => state.managers,
    getLoading: state => state.loading,
  },
  actions: {
    fetchManagers({ commit }) {
      commit(SET_LOADING, true)
      Managers.getList()
        .then(res => commit(UPDATE_MANAGERS, res.data))
        .catch(() => commit(SET_LOADING, false))
    },
  },
  mutations: {
    [UPDATE_MANAGERS]: (state, { items }) => {
      state.managers = items
      state.loading = false
    },
    [DELETE_MANAGER]: (state, { id }) => {
      state.managers.splice(
        state.managers.findIndex(i => i.id === id),
        1,
      )
    },
    [SET_LOADING]: (state, flag) => {
      state.loading = Boolean(flag)
    },
  },
}
